export default __webpack_public_path__ + "static/media/poker-mobile.aae05922.png";